<style lang="scss" scoped>
.email-format {
}
.security-warning {
    background-color: #fdf6ec;
    font-size: 12px;
    color: #E6A23C;
    text-align: center; 
}
</style>
<template lang="pug">
div.email-format
    el-form(label-position="top")
        el-form-item(label="How many letters from the first name do you want to use?")
            el-input-number(:min="2", :max="5", size="medium", v-model="lettersToUseFirstN")
        el-form-item(label="How many letters from the last name do you want to use?")
            el-input-number(:min="2", :max="5", size="medium", v-model="lettersToUseLastN")
        el-form-item(:label="fieldLabel || 'Email format'")
            el-select(v-model="emailFormat", @change="changeDBFormat" style="width: 100%")
                el-option(label="Custom...", value="custom")
                el-option-group(v-for="(group, i) in formats" :key="i" :label="group.label" :value="group.value")
                    el-option(v-for="(item, j) in group.options" :key="item.label" :label="`${item.label}`" :value="item.value")
        el-form-item(label="Custom format", v-if="emailFormat === 'custom'")
            template(v-if="!detectJS()")
                el-input(v-model="customFormat", style="width:90%", ref="customFormatInput", @change="changeDBFormat")
                el-select(v-model="chunkPicker", style="width:10%", @change="changeChunk")
                    el-option(label="+", value="+")
                    el-option(v-for="(field, j) in Object.keys(fieldNames)" :key="field" :value="field" :label="`${fieldNames[field].label} (${field})`" v-if="!excludedFields.includes(field)")
                el-alert(type="warning" style="line-height: 20px" description="{number} will be automatically appended at the end of the format when not selected to prevent duplicate email addresses. A number will only be appended if there is otherwise to be a duplicate email address added when creating a user.")
            template(v-else)
                div.security-warning
                    span Format is hidden for security purposes 
                    el-button(type="text", @click="reset") Overwrite
        el-form-item
            el-table(:data="users")
                el-table-column(label="First Name",  prop="firstname", width="150")
                el-table-column(label="Surname", prop="surname", width="150")
                el-table-column(label="Generated Email Address")
                    template(slot-scope="scope", ref="parentSlot")
                        p {{ applyFormat(scope.row) }}
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";

export default {
    props: {
        userType: String,
        fieldLabel: String,
        domain: String,
        excludedFields: Array,
        settingsType: String,
    },
    data() {
        return {
            firstNames: ["Liam", "Olivia", "Noah", "Emma", "Ava", "William", "Sophia", "James", "Isabella", "Logan", "Mia", "Benjamin", "Charlotte", "Mason", "Amelia", "Elijah", "Harper", "Alexander", "Evelyn", "Daniel"],
            surnames: ["Johnson", "Smith", "Anderson", "Williams", "Jones", "Brown", "Taylor", "Davis", "Miller", "Moore", "Clark", "Wilson", "Anderson", "White", "Thomas", "Harris", "Lewis", "Hall", "Adams", "Baker"],
            users: [],
            usingRawJS: false,
            lettersToUseFirstN: 0,
            lettersToUseLastN: 0,
            dbFields: {
                "last_name": "surname",
                "first_name": "firstname",
                "last_name_letters[0]": "surname-initial",
                "first_name_letters[0]": "firstname-initial",
                "email": "email",
                "cohort_year.toString().slice(-2)": "cohort-year",
                "mis_id": "mis-id",
                "mis_secondary_id": "mis-secondary-id",
                "education_details.admission_number": "admission-number",
                "education_details.year_of_admission.toString()": "admission-date",
                "education_details.year_of_admission.toString().slice(-2)": "admission-year",
                "education_details.learner_number": "learner-number",
                "number": "number",
                "mis_email": "mis-email",
                "mis_email_username": "mis-email-username",
                "work_email": "work-email",
                "work_email_username": "work-email-username",
                "upi": "upi",
                "identifiers.barcode": "student-barcode",
                "identifiers.department_id": "education-department-id",
                "regional_data.government_id": "government-id",
                "regional_data.usi": "usi",
                "education_details.upn": "upn",
                "education_details.la_upn": "la-upn",
            },
            fieldNames: {
                "surname": {
                    label: "Last name",
                    value: "last_name"
                },
                "firstname": {
                    label: "First name",
                    value: "first_name"
                },
                "surname-initial": {
                    label: "Last name initial",
                    value: "last_name_letters[0]"
                },
                "firstname-initial": {
                    label: "First name initial",
                    value: "first_name_letters[0]"
                },
                "email": {
                    label: "Email local part",
                    value: "email"
                },
                "cohort-year": {
                    label: "Cohort year",
                    value: "cohort_year.toString().slice(-2)"
                },
                "mis-id": {
                    label: "MIS ID",
                    value: "mis_id"
                },
                "mis-secondary-id": {
                    label: "MIS Secondary ID",
                    value: "mis_secondary_id"
                },
                "mis-email": {
                    label: "MIS email address",
                    value: "mis_email"
                },
                "mis-email-username": {
                    label: "MIS email address excluding domain",
                    value: "mis_email_username"
                },
                "work-email": {
                    label: "Work email address",
                    value: "work_email"
                },
                "work-email-username": {
                    label: "Work email address excluding domain",
                    value: "work_email_username"
                },
                "admission-number": {
                    label: "Admission number",
                    value: "education_details.admission_number"
                },
                "admission-date": {
                    label: "Admission date",
                    value: "education_details.year_of_admission.toString()"
                },
                "admission-year": {
                    label: "Admission year",
                    value: "education_details.year_of_admission.toString().slice(-2)"
                },
                "learner-number": {
                    label: "Learner number",
                    value: "education_details.learner_number"
                },
                "number": {
                    label: "Number",
                    value: "number"
                },
                "upi": {
                    label: "Unique Person Identifier",
                    value: "upi"
                },
                "student-barcode": {
                    label: "Student Barcode",
                    value: "identifiers.barcode"
                },
                "education-department-id": {
                    label: "Education Department ID",
                    value: "identifiers.department_id"
                },
                "government-id": {
                    label: "Government ID",
                    value: "regional_data.government_id"
                },
                "usi": {
                    label: "Australian Unique Student Identifier",
                    value: "regional_data.usi"
                },
                "upn": {
                    label: "UK Unique Pupil Number",
                    value: "education_details.upn"
                },
                "la-upn": {
                    label: "UK Local Authority UPN",
                    value: "education_details.la_upn"
                },

            },
            formats: [{
                label: 'Standard formats',
                options: [{
                    value: '{surname}{firstname-initial}',
                    label: '{surname}{firstname-initial}'
                }, {
                    value: '{surname}.{firstname-initial}',
                    label: '{surname}.{firstname-initial}'
                }, {
                    value: '{firstname}.{surname-initial}{cohort-year}',
                    label: '{firstname}.{surname-initial}{cohort-year}'
                }]
            }],
            emailFormat: "custom",
            customFormat: "",
            chunkPicker: "+",
            dbFormat: "",
            original: ""
        };
    },

    watch: {
        dbFormat() {
            this.updateModel();
        },
        lettersToUseFirstN() {
            this.addLettersSliceOptions('firstN');
            this.updateModel();
        },
        lettersToUseLastN() {
            this.addLettersSliceOptions('lastN');
            this.updateModel();
        }
    },

    apollo: {
        persistedFormat: {
            query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        id
                        email_format_employee
                        email_format_student
                        email_format_student_split_by_firstN
                        email_format_employee_split_by_firstN
                        email_format_student_split_by_lastN
                        email_format_employee_split_by_lastN
                    }
                }
            `,
            variables() {
                return {
                    type: this.settingsType || "school",
                }
            },
            update(r) {
                this.original = r.Settings[`email_format_${this.userType}`];
                this.customFormat = this.convertToDisplayFormat();
                this.lettersToUseFirstN = r.Settings[`email_format_${this.userType}_split_by_firstN`];
                this.lettersToUseLastN = r.Settings[`email_format_${this.userType}_split_by_lastN`];
                this.changeDBFormat();
                this.updateModel();
            }
        },
    },
    mounted() {
        this.addLettersSliceOptions('both')
    },
    created() {
        for (let i = 0; i < 3; i++) this.users.push(this.makeUser());
    },

    methods: {
        addLettersSliceOptions(toAdd) {
            switch (toAdd) {
                case 'firstN':
                    this.fieldNames[`firstname-${this.lettersToUseFirstN}-letters`] = {label: `First name ${this.lettersToUseFirstN} letters`, value: `first_name_letters.slice(0, ${this.lettersToUseFirstN})`}
                    this.dbFields[`first_name_letters.slice(0, ${this.lettersToUseFirstN})`] = `firstname-${this.lettersToUseFirstN}-letters`;
                    break;
                case 'lastN':
                    this.fieldNames[`surname-${this.lettersToUseLastN}-letters`] = {label: `Last name ${this.lettersToUseLastN} letters`, value: `last_name_letters.slice(0, ${this.lettersToUseLastN})`};
                    this.dbFields[`last_name_letters.slice(0, ${this.lettersToUseLastN})`] = `surname-${this.lettersToUseLastN}-letters`;
                    break;
                default:
                    this.fieldNames[`firstname-${this.lettersToUseFirstN}-letters`] = {label: `First name ${this.lettersToUseFirstN} letters`, value: `first_name_letters.slice(0, ${this.lettersToUseFirstN})`}
                    this.dbFields[`first_name_letters.slice(0, ${this.lettersToUseFirstN})`] = `firstname-${this.lettersToUseFirstN}-letters`;
                    this.fieldNames[`surname-${this.lettersToUseLastN}-letters`] = {label: `Last name ${this.lettersToUseLastN} letters`, value: `last_name_letters.slice(0, ${this.lettersToUseLastN})`};
                    this.dbFields[`last_name_letters.slice(0, ${this.lettersToUseLastN})`] = `surname-${this.lettersToUseLastN}-letters`;
                break;
            }
        },
        makeUser() {
            return {
                surname: this.getRandom(this.surnames),
                firstname: this.getRandom(this.firstNames),
                cohort: Math.floor(Math.random() * 20) + 2000,
                misId: this.getUid(),
                misSecondaryId: this.getUid(),
                admissionNumber: Math.floor(Math.random() * 100000),
                admissionDate: new Date('2018-03-01'),
                learnerNumber: Math.floor(Math.random() * 100000)
            };
        },

        getUid() {
            return Math.floor(Math.random() * 100000);
        },

        getRandom(arr) {
            return arr[Math.floor(Math.random() * (arr.length - 1))];
        },
        
        applyFormat(user) {
            const last_name = user.surname;
            const first_name = user.firstname;
            const last_name_letters = last_name;
            const first_name_letters = first_name;
            let email, mis_email, work_email, work_email_username, mis_email_username;
            email = mis_email = work_email = work_email_username = mis_email_username = first_name + last_name;
            const cohort_year = Math.floor(Math.random() * 20) + 2000;
            const mis_id = this.getUid();
            const mis_secondary_id = this.getUid();
            const education_details = {
                year_of_admission: new Date(new Date('2018-03-01') || null).getFullYear().toString() || '',
                learner_number: Math.floor((Math.random() * 100000)),
                upn: Math.floor((Math.random() * 100000)),
                la_upn: Math.floor((Math.random() * 100000)),
                admission_number: Math.floor((Math.random() * 100000)),
            }
            const regional_data = {
                usi: Math.floor((Math.random() * 100000)),
                government_id: Math.floor((Math.random() * 100000)),
            }
            const identifiers = {
                barcode: Math.floor((Math.random() * 100000)),
                department_id: Math.floor((Math.random() * 100000)),
            }
            const number = Math.floor((Math.random() * 100000));
            const upi = Math.floor((Math.random() * 100000));

            this.usingRawJS = this.detectJS();

            const format = this.detectJS() ? this.original : this.dbFormat;

            return _.deburr(eval(format))
                .toLowerCase() + `@${this.domain || "edusync.com"}`;
        },

        detectJS() {
            const jsPattern = /(?:break|case|catch|class|const|window|console|alert|eval|Function|setTimeout|setInterval|decodeURI|encodeURI|parseInt|toString|alert|eval|setTimeout|setInterval|Function|decodeURI|encodeURI|parseInt|toString|of)|function\s+([a-zA-Z_$][0-9a-zA-Z_$]*)/i
            return jsPattern.test(this.customFormat);
        },

        findMatches(searchString) {
            const matches = [];

            for (const key in this.dbFields) {
                if (searchString.includes(key)) {
                    matches.push({ key, value: this.dbFields[key] });
                }
            }

            return matches;
        },

        changeChunk() {
            const customFormatInput = this.$refs.customFormatInput.$refs.input
            let start = customFormatInput.selectionStart;
            let end = customFormatInput.selectionEnd;
            const customFormatValue = Object.assign(this.customFormat);
            const chunkPickerValue = Object.assign(this.chunkPicker);
            this.customFormat = `${customFormatValue.slice(0, start)}{${chunkPickerValue}}${customFormatValue.slice(end)}`;
            start = end = start + `{${chunkPickerValue}}`.length;
            this.changeDBFormat();
            this.chunkPicker = "+";
            this.updateModel();
        },

        changeDBFormat() {
            const chunks = this.getFormat().split(/(\{.*?\})/);
            this.dbFormat = _(chunks)
                .filter((chunk) => {
                    return !_.isEmpty(chunk);
                })
                .map((chunk) => {
                    const key = chunk.replaceAll(/\{|\}/g, "");
                    return this.fieldNames[key] ? `${this.fieldNames[key].value}` : `'${chunk}'`;
                })
                .value()
                .join(" + ");
        },

        convertToDisplayFormat() {
            const chunks = this.original.split(" + ");
            return _(chunks).map((chunk) => {
                return this.dbFields[chunk] ? `{${this.dbFields[chunk]}}` : chunk.replaceAll(/\'/g, "");
            })
            .value()
            .join("");
        },

        updateModel() {
            this.$emit("input", {
                format: this.dbFormat,
                sample: this.users.length ? this.applyFormat(this.users[0]) : "",
                usingBrokenJS: this.usingRawJS,
                countFirstN: this.lettersToUseFirstN,
                countLastN: this.lettersToUseLastN,
            });
        },

        getFormat() {
            return this.emailFormat === "custom" ? this.customFormat : this.emailFormat;
        },

        reset() {
            this.original = '';
            this.customFormat = '';
            this.changeDBFormat();
        }
    }
};
</script>

